'use strict';

var classChecks = require('../../common/var/classChecks'),
    addSingular = require('./addSingular'),
    addInflection = require('./addInflection');

var isString = classChecks.isString;

function addPlural(singular, plural) {
  plural = plural || singular;
  addInflection('plural', singular, plural);
  if (isString(singular)) {
    addSingular(plural, singular);
  }
}

module.exports = addPlural;